<template>
  <CardPrimary
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <div :style="style.userRow">
      <UserImagePrimary
        :disableLink="true"
        :size="userImageSize"
        :tenantUser="tenantUser"
      />
      <HeaderMediumPrimary
        :truncate="true"
        :style="style.userName"
      >
        {{ firstName }} {{ lastName }}
      </HeaderMediumPrimary>
    </div>
    <div :style="style.row">
      <TextRegular>
        Page views in last 30 days
      </TextRegular>
      <HeaderMediumPrimary>
        {{ tenantUserDiagnose.tenantUserVisitCount }}
      </HeaderMediumPrimary>
    </div>
    <div :style="style.buttonRow">
      <ButtonWideSecondary
        @click="goToMyPage"
        :style="style.button"
      >
        View my page
      </ButtonWideSecondary>
    </div>
    <div :style="style.line">
    </div>
    <div :style="style.row">
      <HeaderMediumPrimary :truncate="true">
        {{ tenant.name }}
      </HeaderMediumPrimary>
    </div>
    <div :style="style.row">
      <TextRegular>
        Total users
      </TextRegular>
      <LinkBoldPrimary :to="{ name: 'workspace' }">
        {{ tenantDiagnose.tenantUserCount }}
      </LinkBoldPrimary>
    </div>
    <div :style="style.row">
      <TextRegular>
        Total skills
      </TextRegular>
      <LinkBoldPrimary :to="{ name: 'skill-explorer' }">
        {{ tenantDiagnose.tenantUserSkillCount }}
      </LinkBoldPrimary>
    </div>
    <div :style="style.row">
      <TextRegular>
        Searches in last 30 days
      </TextRegular>
      <HeaderMediumPrimary>
        {{ tenantDiagnose.expertSearchBySkillCount }}
      </HeaderMediumPrimary>
    </div>
    <div :style="style.buttonRow">
      <ButtonWideSecondary
        @click="goToWorkspacePage"
        :style="style.button"
      >
        View workspace page
      </ButtonWideSecondary>
    </div>
  </CardPrimary>
</template>

<script>
  import ButtonWideSecondary from '@modules/v2/button/button-wide-secondary'
  import CardPrimary from '@modules/v2/card/card-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import LinkBoldPrimary from '@modules/v2/link/link-bold-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import UserImagePrimary from '@modules/v2/image/user-image-primary'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Summary',
    inheritAttrs: false,
    components: {
      ButtonWideSecondary,
      CardPrimary,
      HeaderMediumPrimary,
      LinkBoldPrimary,
      TextRegular,
      UserImagePrimary,
    },
    props: {
      tenant: {
        type: Object,
        required: false,
        default: () => {},
      },
      tenantDiagnose: {
        type: Object,
        required: false,
        default: () => {},
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => {},
      },
      tenantUserDiagnose: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        userImageSize: Layout.space.lg,
        style: {
          buttonRow: {
            alignItems: 'center',
            display: 'flex',
            height: '65px',
            width: '100%',
          },
          button: {
            width: '100%',
          },
          card: {
            padding: Layout.space.md,
            width: '100%',
          },
          line: {
            height: '1px',
            margin: `${Layout.space.md} 0`,
            width: '100%',
          },
          row: {
            alignItems: 'center',
            display: 'flex',
            height: '40px',
            justifyContent: 'space-between',
            width: '100%',
          },
          userName: {
            padding: `0 0 0 ${Layout.space.sm}`,
            width: 'calc(100% - 24px)',
          },
          userRow: {
            alignItems: 'center',
            display: 'flex',
            height: '40px',
            width: '100%',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.line,
        {
          backgroundColor: this.color.dark5(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      firstName: function () {
        return this.tenantUser?.user?.firstName;
      },
      lastName: function () {
        return this.tenantUser?.user?.lastName;
      },
    },
    methods: {
      goToMyPage: function () {
        this.$router.push({
          name: 'user',
          params: {
            id: this.tenantUser.id,
          },
        });
      },
      goToWorkspacePage: function () {
        this.$router.push({
          name: 'workspace',
        });
      },
    },
  };
</script>
